import { get, put } from './';
import qs from 'qs';

export const getCurrencyExchangeRates = ({ filters }) =>
  get(`/currency-rates?${qs.stringify(filters)}`);

export const modifyCurrencyExchangeRates = (organizationId, payload) =>
  put(`/currency-rates?${qs.stringify(organizationId)}`, payload);
